export * from './nav-arrows';

//# sourceMappingURL=index.js.map